import { graphql } from "@opensea/graphql"

export const CurrencyIdentifierFragment = graphql(`
  fragment CurrencyIdentifier on Currency {
    contractAddress
    chainIdentifier
  }
`)
